import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Logo from "@/components/Logo";
import { api } from "@/lib/api";

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const token = searchParams.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, message: "" });

  useEffect(() => {
    if (!email || !token) {
      setState({ loading: false, ok: false, message: "This unsubscribe link is missing required parameters." });
      return;
    }
    const run = async () => {
      try {
        const res = await api.get(`/unsubscribe?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`);
        setState({ loading: false, ok: true, message: res.data?.message || "You've been unsubscribed." });
      } catch (err) {
        setState({
          loading: false,
          ok: false,
          message: err.response?.data?.detail || "We couldn't process this unsubscribe link. It may have expired.",
        });
      }
    };
    run();
  }, [email, token]);

  return (
    <div className="min-h-screen bg-mm-parchment bg-topo flex flex-col" data-testid="unsubscribe-page">
      <div className="container mx-auto py-6">
        <Link to="/"><Logo size={44} /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white border border-mm-navy/10 rounded-2xl p-8 fade-up">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-mm-steel">Email preferences</div>
          <h1 className="font-heading text-3xl font-black text-mm-navy mt-2">
            {state.loading ? "Updating your preferences…" : state.ok ? "You're unsubscribed" : "Couldn't unsubscribe"}
          </h1>
          {!state.loading && (
            <p
              className={`mt-3 text-sm ${state.ok ? "text-mm-navy/80" : "text-red-700"}`}
              data-testid="unsubscribe-message"
            >
              {state.message}
            </p>
          )}
          {state.ok && email && (
            <p className="mt-3 text-xs text-mm-navy/60">
              Affected email: <span className="font-mono">{email}</span>
            </p>
          )}
          <div className="text-sm text-mm-navy/70 mt-6 text-center">
            <Link to="/" className="font-bold text-mm-navy hover:text-mm-steel" data-testid="unsubscribe-home-link">
              Back to Mind Map
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
